export default {"src":"/_next/static/media/WhoWeAre_045A.fb029ccf.JPG","height":706,"width":1920};